import {
  InvalidOptionLine,
  NoDefaultOptionConstraint,
  NotOnMenuCard,
  QuantityEscalationItem,
  UnmatchedCoupon,
} from '../../../reducers/messagingSlice';

const SLICE_NAME = 'unresolvedItemsSlice';

// TTS message sent to the customer before the readback when the agent clicks
// "Dismiss & Readback". Kept as a constant so it's easy to tune without digging
// through component code.
const DISMISS_READBACK_TTS = 'ok, so far';

// Stable identity keys used as React list keys when rendering cards.
const KEY_SEPARATOR = '␟';

const buildNotOnMenuKey = (card: Pick<NotOnMenuCard, 'item'>): string =>
  `${card.item}`;

const buildInvalidOptionKey = (
  line: Pick<InvalidOptionLine, 'option' | 'constraint' | 'is_top_level'>
): string =>
  [line.option, line.constraint ?? '', String(line.is_top_level)].join(
    KEY_SEPARATOR
  );

const buildQuantityEscalationKey = (
  item: Pick<QuantityEscalationItem, 'item_name' | 'quantity' | 'threshold'>
): string =>
  [item.item_name, String(item.quantity), String(item.threshold)].join(
    KEY_SEPARATOR
  );

const buildNoDefaultOptionKey = (
  entry: Pick<NoDefaultOptionConstraint, 'constraint' | 'parent_item'>
): string => [entry.constraint, entry.parent_item].join(KEY_SEPARATOR);

const buildUnmatchedCouponKey = (
  entry: Pick<UnmatchedCoupon, 'coupon'>
): string => `${entry.coupon}`;

export {
  SLICE_NAME,
  DISMISS_READBACK_TTS,
  buildNotOnMenuKey,
  buildInvalidOptionKey,
  buildQuantityEscalationKey,
  buildNoDefaultOptionKey,
  buildUnmatchedCouponKey,
};
